import { Pages } from '@/constants/rutas';

export const SeoImages = {
    [Pages.ESTADISTICAS_FANTASY_JUGADORES]: `2024/secciones/estadisticas-fantasy.jpg`,
    [Pages.MERCADO]: `2024/secciones/mercado-laliga.jpg`,
    [Pages.MERCADO_EQUIPOS]: `2024/secciones/mercado-laliga.jpg`,
    [Pages.NOTICIAS]: `2024/secciones/noticias.jpg`,
    [Pages.INICIO]: `2024/secciones/inicio.jpg`,
    [Pages.ANALIZA_TU_PLANTILLA]: `2024/secciones/alineaciones-probables.jpg`,
    [Pages.COMPARADOR_DE_JUGADORES]: `2024/secciones/comparador-jugadores.jpg`,
    [Pages.LESIONADOS_SANCIONADOS_APERCIBIDOS]: `2024/secciones/alineaciones-probables.jpg`,
    [Pages.CLASIFICACION]: `2024/secciones/alineaciones-probables.jpg`,
    [Pages.ONCE_IDEAL]: `2024/secciones/alineaciones-probables.jpg`,
    [Pages.LANZADORES_PENALTIS]: `2024/secciones/alineaciones-probables.jpg`,
    [Pages.ESTADISTICAS_DEL_JUGADOR_DEFAULT]: `2024/secciones/estadisticas-fantasy.jpg`,
    [Pages.LIDERES_POR_JORNADAS]: `2024/secciones/alineaciones-probables.jpg`,
    [Pages.MEJORES_RACHAS]: `2024/secciones/mejores-rachas.jpg`,
    [Pages.INICIA_SESION]: `2024/secciones/alineaciones-probables.jpg`,
    [Pages.REGISTRATE]: `2024/secciones/alineaciones-probables.jpg`,
    [Pages.MIS_PLANTILLAS]: `2024/secciones/alineaciones-probables.jpg`,
    [Pages.EDITAR_PLANTILLA]: `2024/secciones/alineaciones-probables.jpg`,
    [Pages.CREAR_PLANTILLA]: `2024/secciones/alineaciones-probables.jpg`,
    [Pages.TERMINOS_CONDICIONES]: `2024/secciones/alineaciones-probables.jpg`,
    [Pages.POLITICAS_PRIVACIDAD]: `2024/secciones/alineaciones-probables.jpg`,
    [Pages.CONTACTANOS]: `2024/secciones/alineaciones-probables.jpg`,
    [Pages.PARTIDO]: `partido.jpg`,
    [Pages.CALENDARIO_FANTASY]: `2024/secciones/alineaciones-probables.jpg`,
    [Pages.REESTABLECER_CONTRASENA]: `2024/secciones/alineaciones-probables.jpg`,
    [Pages.ANALISIS_PLANTILLA]: `2024/secciones/alineaciones-probables.jpg`,
    [Pages.ENCUESTA_DE_SATISFACCION]: `2024/secciones/alineaciones-probables.jpg`,
    [Pages.PERFIL_DE_USUARIO]: `2024/secciones/alineaciones-probables.jpg`,
    [Pages.OLVIDASTE_TU_CONTRASENA]: `2024/secciones/alineaciones-probables.jpg`,
    [Pages.FANTASY_MANAGER]: `2024/secciones/alineaciones-probables.jpg`,
    [Pages.PREDICTING_MANAGER]: `banners/predicting-manager.jpg`,
    [Pages.PREDICTING_MANAGER_RANKING]: `banners/predicting-manager.jpg`,
    [Pages.ADMINISTRADOR_JUGADORES]: `2024/secciones/alineaciones-probables.jpg`,
    [Pages.PREDICTING_MANAGER_ALINEACIONES]: `banners/predicting-manager.jpg`,
    [Pages.PREDICTING_MANAGER_RULES]: `banners/predicting-manager.jpg`,
    [Pages.EQUIPO]: `2024/secciones/alineaciones-probables.jpg`,
    [Pages.ALINEACIONES_PROBABLES]: `2024/secciones/alineaciones-probables.jpg`,
    [Pages.COLABORADORES]: `2024/secciones/alineaciones-probables.jpg`,
    [Pages.COLABORADORES_NOTICIAS]: `2024/secciones/noticias.jpg`,
    [Pages.JUGADORES]: `2024/secciones/alineaciones-probables.jpg`,
    [Pages.QUINIELA_JUEGO]: `2024/secciones/alineaciones-probables.jpg`,
    [Pages.PUJA_FANTASY]: `2024/secciones/puja-ideal.jpg`,
    [Pages.PUJA_FANTASY_BIWENGER]: `2024/secciones/puja-ideal.jpg`,
    [Pages.QUINIELA_CLASIFICACION]: `2024/secciones/alineaciones-probables.jpg`,
    [Pages.QUINIELA_REGLAS_DEL_JUEGO]: `2024/secciones/alineaciones-probables.jpg`,
    [Pages.JUGADORES_LESIONADOS]: `2024/secciones/estado-jugadores.jpg`,
    [Pages.JUGADORES_SANCIONADOS]: `2024/secciones/estado-jugadores.jpg`,
    [Pages.JUGADORES_DUDAS]: `2024/secciones/estado-jugadores.jpg`,
    [Pages.NOTICIAS_FLASH]: `2024/secciones/alineaciones-probables.jpg`,
    [Pages.CALENDARIO_COMPETICIONES]: `2024/secciones/alineaciones-probables.jpg`,
    [Pages.JUGADORES_APERCIBIDOS]: `2024/secciones/estado-jugadores.jpg`,
    [Pages.CONVOCATORIAS]: `2024/secciones/alineaciones-probables.jpg`,
    [Pages.VIRUS_FIFA]: `virus-fifa.png`,
    [Pages.APUESTAS_DEPORTIVAS]: `2024/secciones/alineaciones-probables.jpg`,
    [Pages.MERCADO_FICHAJES]: `2024/secciones/mercado-laliga.jpg`,
    [Pages.MERCADO_BIWENGER]: `2024/secciones/mercado-laliga.jpg`,
    [Pages.ESTADISTICAS_BIWENGER]: `2024/secciones/estadisticas-fantasy.jpg`,
    [Pages.LIDERES_ESTADISTICAS]: `2024/secciones/estadisticas-fantasy.jpg`,
    [Pages.INSTALL_APP]: `2024/secciones/alineaciones-probables.jpg`,
    [Pages.PREMIOS_Y_SORTEOS]: `2024/secciones/alineaciones-probables.jpg`,
    [Pages.ACTIVIDADES]: `2024/secciones/actividades.jpg`,
    [Pages.SALON_DE_LA_FAMA]: `2024/secciones/alineaciones-probables.jpg`,
    [Pages.CHOLLOS_FANTASY_BIWENGER]: `2024/secciones/alineaciones-probables.jpg`,
    [Pages.CHOLLOS_FANTASY_RELEVO]: `2024/secciones/alineaciones-probables.jpg`,
    [Pages.CHOLLOS_FANTASY_MARCA]: `2024/secciones/alineaciones-probables.jpg`,
    [Pages.QUEDADA_FANTASY]: `2024/secciones/alineaciones-probables.jpg`,
    [Pages.TIER_LIST]: `2024/secciones/tierlist.jpg`,
    [Pages.TIER_LIST_PUBLIC]: `2024/secciones/tierlist.jpg`,
    [Pages.EDIT_TIER_LIST]: `2024/secciones/tierlist.jpg`,
    [Pages.NUEVA_TIER_LIST]: `2024/secciones/tierlist.jpg`,
    [Pages.VISUALIZAR_TIER_LIST]: `2024/secciones/tierlist.jpg`,
    [Pages.FANTASY_DAZN_FALLECIO]: `fantasy-la-liga-down.webp`,
    [Pages.KIT_DIGITAL]: `2024/secciones/alineaciones-probables.jpg`,
    [Pages.ORACULO_FANTASY]: `2024/secciones/oraculo-fantasy.jpg`,
    [Pages.SITIOS_RECOMENDADOS]: `2024/secciones/alineaciones-probables.jpg`,
    [Pages.CREADORES_CONTENIDO]: `2024/secciones/alineaciones-probables.jpg`,
    [Pages.PUNTUACIONES_FANTASY]: `2024/secciones/alineaciones-probables.jpg`,
    [Pages.PREPARADOR_JORNADA]: `2024/secciones/alineaciones-probables.jpg`,
    [Pages.NOVEDADES]: `2024/secciones/alineaciones-probables.jpg`,
    [Pages.PREMIUM]: `2024/secciones/alineaciones-probables.jpg`,
    [Pages.PREMIUM_ACTIVIDADES]: `2024/secciones/alineaciones-probables.jpg`,
    [Pages.ANALISIS_POST_PARTIDO]: `2024/secciones/alineaciones-probables.jpg`,
    [Pages.SALDO_ARBITRAL_PARTIDOS]: `2024/tarjetas/tarjetas-amarillas.jpg`,
    [Pages.SALDO_ARBITRAL_PARTIDOS_ROJAS]: `2024/tarjetas/tarjetas-rojas.jpg`,
    [Pages.CENTRO_INFORMACION]: `2024/secciones/alineaciones-probables.jpg`,
    [Pages.BUSCADOR_DE_JUGADORES]: `2024/secciones/alineaciones-probables.jpg`,
    [Pages.GUIAS_FANTASY]: `2024/secciones/alineaciones-probables.jpg`,
    [Pages.GUIAS_FANTASY_FANTASY_MARCA]: `2024/secciones/alineaciones-probables.jpg`,
    [Pages.GUIAS_FANTASY_FANTASY_BIWENGER]: `2024/secciones/alineaciones-probables.jpg`,
    [Pages.GUIAS_FANTASY_FANTASY_LA_LIGA]: `2024/secciones/alineaciones-probables.jpg`,
    [Pages.GUIAS_FANTASY_FANTASY_MISTER]: `2024/secciones/alineaciones-probables.jpg`,
    [Pages.MERCADO_DAZN]: `2024/secciones/mercado-laliga.jpg`,
    [Pages.CHOLLOS_FANTASY_MISTER]: `2024/secciones/mercado-laliga.jpg`,
    [Pages.MISTER_FANTASY_MERCADO]: `2024/secciones/mercado-laliga.jpg`,
    [Pages.MISTER_FANTASY_MERCADO_EQUIPOS]: `2024/secciones/mercado-laliga.jpg`,
    [Pages.MISTER_FANTASY_SUBIDAS_Y_BAJADAS]: `2024/secciones/mercado-laliga.jpg`,
    [Pages.RULETA_FANTASY]: `2024/secciones/alineaciones-probables.jpg`,
    [Pages.RULETA_FANTASY_RANKING]: `2024/secciones/alineaciones-probables.jpg`,
    [Pages.RULETA_FANTASY_RANKING_GLOBAL]: `2024/secciones/alineaciones-probables.jpg`,
};
